'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'bell-concierge';
var width = 512;
var height = 512;
var aliases = [128718,"concierge-bell"];
var unicode = 'f562';
var svgPathData = ['M48 368c0-114.9 93.1-208 208-208s208 93.1 208 208l0 32L48 400l0-32z', 'M200 64c-4.4 0-8 3.6-8 8s3.6 8 8 8l48 0 0 64.1C128 148.4 32 247 32 368l0 32 16 0 0-32c0-114.9 93.1-208 208-208s208 93.1 208 208l0 32 16 0 0-32c0-121-96-219.6-216-223.9L264 80l48 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-56 0-56 0zM8 432c-4.4 0-8 3.6-8 8s3.6 8 8 8l496 0c4.4 0 8-3.6 8-8s-3.6-8-8-8L8 432z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBellConcierge = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;